import { EditorState } from 'draft-js'
export interface PluginFunctions {
  getEditorState: () => EditorState
  setEditorState: (editorState: EditorState) => void
}

export interface PluginStore {
  subscribeToItem: (key: string, handler: (item: unknown) => void) => void
  unsubscribeFromItem: (key: string, handler: (item: unknown) => void) => void
}
